<div class="tal-code-editor-execbar" [class.blur]="isBlurred">
    <div class="tal-code-editor-execbar-left">
        <h3>{{selectedFile?.name}}</h3>
    </div>

    <div class="tal-code-editor-execbar-right"  >
        <button pButton icon="pi pi-stop" class="tal-square-button" (click)="onStopClick()" pTooltip="Stop Pyodide" tooltipPosition="bottom"></button>
        <button pButton icon="pi pi-play" class="tal-square-button" (click)="onRunClick()" pTooltip="Run locally" tooltipPosition="bottom"></button>
        <button pButton icon="pi pi-cloud-upload" class="tal-square-button" (click)="onConnectClick()" pTooltip="Verify solution with TALight server" tooltipPosition="bottom"></button>
    </div>
</div>
